import { render, staticRenderFns } from "./v-menu-multi-level.vue?vue&type=template&id=22cf68f0&scoped=true"
import script from "./v-menu-multi-level.vue?vue&type=script&lang=js"
export * from "./v-menu-multi-level.vue?vue&type=script&lang=js"
import style0 from "./v-menu-multi-level.vue?vue&type=style&index=0&id=22cf68f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cf68f0",
  null
  
)

export default component.exports